
import { morphSection } from '@theme/section-renderer';
import { CartUpdateEvent } from '@theme/events';
import { debounce, requestIdleCallback } from '@theme/utilities';
import { MODE_NONE, cartMode } from '@theme/offer-mode';
import { autoCodeAction, nextDiscountCodes } from '@theme/bogo-pairing';

let syncing = false;
let pendingResync = false;


function readState() {
  const el = document.querySelector('[data-bogo-auto]');
  if (!(el instanceof HTMLElement)) return null;
  return {
    code: el.dataset.code || '',
    mode: el.dataset.mode || '',
    eligible: el.dataset.eligible === 'true',
    applied: el.dataset.applied === 'true',
  };
}

function cartItemsSectionIds() {
  return Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) =>  (el).dataset.sectionId)
    .filter(Boolean);
}


function refreshCartSections(cart) {
  if (!cart || !cart.sections) return;

  for (const el of document.querySelectorAll('cart-items-component')) {
    const sectionId =  (el).dataset.sectionId;
    const html = sectionId && cart.sections[sectionId];
    if (!html) continue;

    morphSection(sectionId, html, { mode:  (el).dataset.drawer !== undefined ? 'hydration' : 'full' });
    el.dispatchEvent(
      new CartUpdateEvent(cart, sectionId, {
        source: 'bogo-auto',
        itemCount: cart.item_count,
        sections: cart.sections,
      })
    );
  }
}

async function sync() {
  if (syncing) {
    pendingResync = true;
    return;
  }
  syncing = true;

  try {
    const state = readState();
    if (!state || !state.code) return;

    const action = autoCodeAction(state);
    if (!action) return;

    const cart = await fetch(`${Theme.routes.cart_url}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then((response) => response.json());
    if (!cart || !Array.isArray(cart.items)) return;

    // Re-check against the live cart: only ever APPLY to an ordinary cart, and
    // only remove from the mode the render said. A stale render does nothing;
    // the next cart:update brings a fresh one.
    const mode = cartMode(cart.items);
    if (action === 'apply' && mode !== MODE_NONE) return;
    if (action === 'remove' && mode !== MODE_NONE) return;
    if (mode !== state.mode) return;

    const codes = nextDiscountCodes(cart.discount_codes, state.code, action);
    if (!codes) return;

    const sectionIds = cartItemsSectionIds();
    const body = { discount: codes.join(',') };
    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(Theme.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    });
    if (!response.ok) throw new Error(`bogo-auto: /cart/update answered ${response.status}`);
    refreshCartSections(await response.json());
  } catch (error) {
    console.error(error);
  } finally {
    syncing = false;
    if (pendingResync) {
      pendingResync = false;
      sync();
    }
  }
}


document.addEventListener('cart:update', debounce(sync, 700));

// Heal on load too (a cart that qualified before this script existed, or a code
// typed on another device), off the critical path like byob-gift-sync.js.
requestIdleCallback(() => sync(), { timeout: 3000 });
